import { Component, OnChanges, ChangeDetectionStrategy, input } from '@angular/core';
import {UnitRatingResponse} from '../../../model/unit-rating-response';
import {CoilResponse} from '../../../model/coil-response';
import {UnitConversionUtils} from '../../unit-conversion-utils';

@Component({
    selector: 'app-heating-only-performance-results',
    templateUrl: './heating-only-performance-results.component.html',
    styleUrls: ['./heating-only-performance-results.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class HeatingOnlyPerformanceResultsComponent implements OnChanges {

  readonly isMetric = input(false);
  readonly ratingResponse = input.required<UnitRatingResponse>();
  heatingTotalCapacity = 0;
  heatingLeavingDryBulb = 0;
  heatingFluidFlowRate = 0;
  heatingFluidTemperatureChange = 0;
  heatingLeavingFluidTemperature = 0;
  heatingFluidPressureDrop = 0;
  electricHeatLeavingDryBulb = 0;

  constructor() {
  }

  ngOnChanges(): void {
    this.clearOutputValues();
    if (this.ratingResponse()) {
      const primaryCoil = this.ratingResponse().PrimaryCoilResponse;
      if (primaryCoil) {
        this.setHeatingProperties(primaryCoil);
      }
      const electricHeat = this.ratingResponse().ElectricHeatResponse;
      if (electricHeat) {
        this.electricHeatLeavingDryBulb = electricHeat.LeavingDryBulbTemperature;
      }
    }
  }

  private setHeatingProperties(coilResponse: CoilResponse): void {
    this.heatingTotalCapacity = coilResponse.TotalCapacity;
    this.heatingLeavingDryBulb = coilResponse.LeavingDryBulbTemperature;
    this.heatingFluidFlowRate = coilResponse.FluidFlowRate;
    this.heatingFluidTemperatureChange = coilResponse.FluidTemperatureChange;
    this.heatingLeavingFluidTemperature = coilResponse.LeavingFluidTemperature;
    this.heatingFluidPressureDrop = coilResponse.FluidPressureDrop;
  }

  private clearOutputValues(): void {
    this.heatingTotalCapacity = 0;
    this.heatingLeavingDryBulb = 0;
    this.heatingFluidFlowRate = 0;
    this.heatingFluidTemperatureChange = 0;
    this.heatingLeavingFluidTemperature = 0;
    this.heatingFluidPressureDrop = 0;
    this.electricHeatLeavingDryBulb = 0;
  }

  getCapacityUnits(): string {
    return UnitConversionUtils.getCapacityUnits(this.isMetric());
  }

  getTemperatureUnits(): string {
    return UnitConversionUtils.getTemperatureUnits(this.isMetric());
  }

  getFluidFlowUnits(): string {
    return UnitConversionUtils.getFlowRateUnits(this.isMetric());
  }

  getPressureDropUnits(): string {
    return UnitConversionUtils.getPressureUnits(this.isMetric());
  }

}
